import axios from 'axios';

export class PromiseOverride extends Promise {
    catch(executor) {
        return super.catch(function (error) {
            if (error && !error.isAxiosError) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            }
            return executor(error);
        });
    }

    async getState() {
        const promise = this;
        const dummy = {};
        return Promise.race([promise, dummy]).then(
            (v) => (v === dummy ? 'pending' : 'fulfilled'),
            () => 'rejected'
        );
    }
}
